import { $isCodeNode } from '@lexical/code';
import { CODE, type MultilineElementTransformer } from '@lexical/markdown';
import { $createTextNode } from 'lexical';

// Keep Lexical's fence/language parsing and shortcut behavior, but do not
// trim the first indentation character or blank lines from persisted code.
export const PRESERVED_CODE: MultilineElementTransformer = {
  ...CODE,
  handleImportAfterStartMatch: (context) => {
    const result = CODE.handleImportAfterStartMatch?.(context);
    if (!result?.[0]) return result;
    const { lines, rootNode, startLineIndex, startMatch } = context;
    const end = result[1];
    const node = rootNode.getLastChild();
    if (end === startLineIndex || !$isCodeNode(node)) return result;

    const fenceLength = startMatch[1].trim().length;
    const closingFence = new RegExp(`^[ \\t]*\`{${fenceLength},}$`);
    const body = lines.slice(
      startLineIndex + 1,
      closingFence.test(lines[end]) ? end : end + 1
    );
    const openingContent = lines[startLineIndex].slice(startMatch[0].length);
    if (openingContent) body.unshift(openingContent);
    node.clear().append($createTextNode(body.join('\n')));
    return result;
  },
};
